export default "__VITE_ASSET__BYBaNtrE__"